module.exports = __webpack_public_path__ + "media/src/images/invoease-21f8d833fa867d9f2467657bd82bf8f5.svg";